import React, { useState, useEffect } from "react";
import { getCertificates, renewCertificate } from "../api/api";
import ResponseDialog from "./dialog/ResponseDialog";

const Certificates = () => {
    const [certificates, setCertificates] = useState([]);
    const [resmessage, setResmessage] = useState("");
    const [typemessage, setTypemessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const loadCertificates = async (renew) => {
        if (renew === 0) {
            setTypemessage("info");
            setResmessage("Loading certificates...");
        }        
        const response = await getCertificates();
        setTypemessage(response.type);
        setResmessage(response.message);
        setCertificates(response.data);
    };

    const renewCert = async (domain) => {
        setIsLoading(true);
        setTypemessage("info");
        setResmessage("Renewing certificate...");
        const response = await renewCertificate(domain);
        setTypemessage(response.type);
        setResmessage(response.message);
        loadCertificates(1);
        setIsLoading(false);
    }

    useEffect(() => {
        loadCertificates(0);
    }, []);

    return (
        
                <div className="card">
                    <div className="card-header">
                        <h5>Certificates list</h5>
                        <span className="d-block m-t-5">list of <code>certificates</code> and their expiry dates</span>
                    </div>
                    <div className="card-body table-border-style">
                        {typemessage && resmessage && <ResponseDialog type={typemessage} message={resmessage} onClose={() => setResmessage("")} />}
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th />
                                        <th>Domain</th>
                                        <th>Expiry</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody id="cert">
                                {certificates.map((certificate, index) => (
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{certificate.name}</td>
                                        <td>{certificate.expiry}</td>
                                        <td>
                                            {isLoading ? (
                                                    <button className="btn  btn-icon btn-primary" type="button" disabled>
                                                        <span className="spinner-border spinner-border-sm" role="status"></span>
                                                        <span className="sr-only">Loading...</span>
                                                    </button>
                                                ):(
                                                    <button type="button" className="btn  btn-icon btn-primary" title="renew"
                                                        onClick={() => renewCert(certificate.name)}>
                                                            <span className="material-symbols-outlined">update</span>
                                                        </button>
                                                )}
                                            
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
    );
};
export default Certificates;